import { render, staticRenderFns } from "./SideControls.vue?vue&type=template&id=694d3a85&scoped=true&"
import script from "./SideControls.vue?vue&type=script&lang=js&"
export * from "./SideControls.vue?vue&type=script&lang=js&"
import style0 from "./SideControls.vue?vue&type=style&index=0&id=694d3a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d3a85",
  null
  
)

export default component.exports